/**
 * Formats a plain number with thousands separators and decimal places
 * based on the numberFormat setting.
 *
 * @param value - The value to format
 * @param numberFormat - 'TWO_DECIMALS' (default) or 'NO_DECIMALS'
 */
export const formatReportNumber = (value: unknown, numberFormat?: string): string => {
  const num = Number(value)
  if (isNaN(num)) {
    return String(value)
  }

  const decimals = numberFormat === 'NO_DECIMALS' ? 0 : 2
  return new Intl.NumberFormat('en', {
    minimumFractionDigits: 0,
    maximumFractionDigits: decimals,
  }).format(num)
}

/**
 * Formats a currency value with thousands separators and decimal places.
 * Always shows decimal places (2 by default, 0 if NO_DECIMALS).
 *
 * @param value - The value to format
 * @param numberFormat - 'TWO_DECIMALS' (default) or 'NO_DECIMALS'
 */
export const formatReportCurrency = (value: unknown, numberFormat?: string): string => {
  const num = Number(value)
  if (isNaN(num)) {
    return String(value)
  }

  const decimals = numberFormat === 'NO_DECIMALS' ? 0 : 2
  return new Intl.NumberFormat('en', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(num)
}
